<template>
  <div class="section-container" v-if="hasMotor && isNotB50">
    <div class="section-top">
      <div class="flex items-center">
        <p class="section-title mr-3">{{ title }}</p>
        <sf-icon @click="openModal" size="lg" :icon="['fas', 'info-circle']" :style="{ cursor: 'pointer', marginTop: '-3px' }" />
      </div>
      <p class="section-number">{{ step }}/{{ totalSteps }}</p>
    </div>
    <div class="section-bottom">
      <div class="flex mb-6" v-html="cardContent"></div>

      <ul>
        <li
          v-for="option in filteredOptions"
          :key="option.id"
          @click="addToSelection(option)"
          class="list-select-item"
          :class="{ 'selected-list-select-item': isSelected(option) }"
        >
          <p>{{ option.variationName || option.name || "" }}</p>
          <p class="font-bold bg-yellow-300 py-1 px-2 w-32 text-right">
            <span class="mr-1">+</span>{{ optionPrice(option) | formatPrice }} €
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { getAttributeValue } from "./plentyHelpers";
import { fetchCategoryContent } from "./Helpers";

export default {
  name: "Lighting",
  props: ["category", "step", "totalSteps"],

  data() {
    return {
      modalContent: "",
      title: "Beleuchtung",
      cardContent: "",
    };
  },

  async created() {
    let { modalContent, title, cardContent } = await this.fetchCategoryContent(this.category, this.$setPreview);
    this.modalContent = modalContent;
    if (title) this.title = title;
    if (cardContent) this.cardContent = cardContent;
  },

  computed: {
    ...mapState("lighting/", {
      options: (state) => state.options,
      selection: (state) => state.selection,
      defaultSelection: (state) => state.defaultSelection,
    }),

    arms() {
      return this.$store.getters["dimensions/numberOfArms"];
    },

    isNotB50() {
      return this.$store.state.set.setItem.id != 950; 
    },

    hasMotor() {
      return this.$store.state.drive?.selection?.id === 4232 || this.$store.state.drive?.selection?.id === 4231; // Not Kurbel option
    },

    filteredOptions() {
      return this.options.filter((option) => {
        if (option.number.includes('-KA')) return false; // Filter out KA- options
        let intendedForArms = getAttributeValue(option, "Arme");
        return this.arms == intendedForArms || intendedForArms == "X" || !intendedForArms;
      });
    },
  },

  methods: {
    ...mapMutations("lighting/", {
      setSelection: "setSelection",
    }),
    getAttributeValue,
    fetchCategoryContent,

    optionPrice(option) {
      if (!option) return 0;
      if (!option.variationSalesPrices) return 0;

      return option.variationSalesPrices[0].price;
    },

    isSelected(option) {
      return this.selection.includes(option);
    },

    addToSelection(option) {
      let selection = this.selection;
      if (!selection) selection = [];

      if (!selection.includes(option)) {
        selection.push(option);
      } else {
        selection = selection.filter((item) => item !== option);
      }

      this.setSelection(selection);
    },

    priceDifference(option) {
      if (!this.selection) return 0;
      if (!this.selection.variationSalesPrices) return 0;

      let optionPrice = option.variationSalesPrices[0].price;
      let selectedPrice = this.selection.variationSalesPrices[0].price;
      return optionPrice - selectedPrice;
    },

    openModal() {
      this.$store.commit("modal/openModal")
      this.$store.dispatch("modal/setBody", this.modalContent);
      this.$store.dispatch("modal/setTitle", this.title);
    },
  },
};
</script>

<style></style>
